import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitStata {
  number: number;
  selectedItem: any; // 当前选中项
}

const initialState: InitStata = {
  number: 0,
  selectedItem: {},
};

const customerSlice = createSlice({
  name: 'predictflow',
  initialState,
  reducers: {
    changeCount: (state = initialState, action: PayloadAction<number>) => {
      state.number = action.payload;
    },
    // 选择对比
    setSelectedItem: (state = initialState, action: PayloadAction<any>) => {
      state.selectedItem = action.payload;
    },
  },
});

// 导出action
export const { changeCount, setSelectedItem } = customerSlice.actions;

export default customerSlice.reducer;
